export default function (state, val) {
    state.list.splice(state.list.indexOf(state.list.filter(i => {
        return i.code === val
    })[0]), 1);
}